<template>
	<div class="countdown-wrapper">
		<svg class="countdown-svg">
			<circle class="countdown-bg" :cx="center" :cy="center" :r="radius" />
			<circle
				class="countdown-mask"
				:cx="center"
				:cy="center"
				:r="radius"
				:stroke-dasharray="circumference"
				:stroke-dashoffset="dashOffset"
				:transform="`rotate(-90 ${center} ${center})`"
			/>
		</svg>

		<span class="countdown-text">{{ remaining }}</span>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
	defineProps<{
		videoDuration: number;
		currentTime?: number;
		size?: number;
	}>(),
	{
		videoDuration: 0,
		currentTime: 0,
		size: 32,
	}
);
const strokeWidth = 2;
const center = computed(() => props.size / 2);
const radius = computed(() => center.value - strokeWidth);
const circumference = computed(() => 2 * Math.PI * radius.value);

const progressTime = computed(() => Math.min(props.currentTime, props.videoDuration));

const dashOffset = computed(() => {
	return ((props.videoDuration - progressTime.value) / props.videoDuration) * circumference.value;
});

const remaining = computed(() => Math.ceil(Math.max(0, props.videoDuration - progressTime.value)));
</script>

<style scoped>
.countdown-wrapper {
	position: relative;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.countdown-svg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.countdown-bg {
	fill: none;
	stroke: #fbc500;
	stroke-width: 2;
}

.countdown-mask {
	fill: none;
	stroke: white;
	stroke-width: 2;
	stroke-linecap: round;
	transition: stroke-dashoffset 1s linear;
}

.countdown-text {
	font-size: 10px;
	font-weight: bold;
	color: white;
	line-height: 1;
	position: relative;
	z-index: 1;
}
</style>
